import { isPlatformNodeJS } from '@utils/common';

/**
 * apply the given set of CSS declarations as inline style on the given element
 * (falling back to the root element)
 */
function applyCssDeclarations(rules, element) {
  const target = (element && "current" in element ? element.current : element) ?? (!isPlatformNodeJS() ? document.querySelector(":root") ?? document.documentElement : undefined);
  if (!target) {
    return;
  }
  for (const [property, value] of Object.entries(rules)) {
    target.style.setProperty(property, value);
  }
}

export { applyCssDeclarations };
//# sourceMappingURL=util.apply-declarations.js.map
